import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">よし鮨</div>
          <p className="footer-address">
            〒071-8143 北海道旭川市春光台３条３丁目９−２５
          </p>
          <p className="footer-tel">
            <a href="tel:0166-53-3032">0166-53-3032</a>
          </p>
          <p className="footer-privacy">
            <a href="/privacy" className="footer-link">
              プライバシーポリシー
            </a>
          </p>
          <p className="footer-copyright">
            &copy; {new Date().getFullYear()} よし鮨 All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

